import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { ConfigModule } from './config/config.module';


@NgModule({
  imports: [
    AdminRoutingModule,
    ConfigModule
  ],
  providers: [
   
  ]
})
export class AdminModule { }
